import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef, useId } from 'react';

import theme from 'theme';

// Source: images/sms-unsubscribed-icon.svg. White separators reveal the background.
export const SmsUnsubscribedIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function SmsUnsubscribedIcon(props, ref) {
    const clipId = useId();
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 16 16"
        width={16}
        height={16}
        fill={theme.palette.secondary.main}
        stroke="none"
        {...props}
      >
        <defs>
          <clipPath id={clipId}>
            <path
              clipRule="evenodd"
              d="M0 0H16V16H0Z M5 11.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0-11 0Z"
            />
          </clipPath>
        </defs>
        <path
          clipPath={`url(#${clipId})`}
          d="M1 0H11C11.2652 0 11.5196 0.105357 11.7071 0.292893C11.8946 0.48043 12 0.734784 12 1V8C12 8.26522 11.8946 8.51957 11.7071 8.70711C11.5196 8.89464 11.2652 9 11 9H8.734H6L2.266 12.3125V9H1C0.734784 9 0.48043 8.89464 0.292893 8.70711C0.105357 8.51957 0 8.26522 0 8V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0Z"
        />
        <path
          fill={theme.palette.error.main}
          fillRule="evenodd"
          d="M6 11.5a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0-9 0Z M10 9h1v3h-1Z M10 13h1v1h-1Z"
        />
      </BaseIcon>
    );
  },
);
